{
  "title": "الإصدارات",
  "description": "سجل التغييرات لكل إصدار، والإصدار الذي يعمل على كل سيرفر.",
  "fleet": {
    "title": "سيرفراتك",
    "columns": {
      "server": "السيرفر",
      "channel": "القناة",
      "version": "الإصدار الحالي",
      "state": "التحديث",
      "checkIn": "آخر اتصال"
    },
    "notInstalled": "غير مثبّت",
    "never": "لم يتصل بعد",
    "empty": "لا توجد سيرفرات بعد",
    "add": "أضف سيرفر",
    "state": {
      "up_to_date": "محدّث",
      "update_available": "{{version}} متاح",
      "security_only": "تحديث أمان {{version}}",
      "not_installed": "بانتظار التثبيت"
    },
    "howTo": "يُحدَّث كل سيرفر من لوحة bPanel عليه، من الإعدادات ثم التحديثات. هناك تختار التحديث التلقائي أو التنبيه فقط، وتحدد القناة لكل سيرفر. السيرفر المقفل، أو غير المتصل منذ مدة، يحصل على تحديثات الأمان فقط.",
    "summary_zero": "كل السيرفرات على آخر إصدار في قناتها.",
    "summary_one": "سيرفر واحد يمكن تحديثه.",
    "summary_two": "يمكن تحديث سيرفرين.",
    "summary_few": "{{count}} سيرفرات يمكن تحديثها.",
    "summary_many": "{{count}} سيرفرًا يمكن تحديثه.",
    "summary_other": "{{count}} سيرفر يمكن تحديثه."
  },
  "changelog": {
    "title": "سجل التغييرات",
    "filter": "عرض الإصدارات",
    "all": "الكل",
    "latest": "الأحدث",
    "empty": "لا توجد إصدارات على هذه القناة",
    "betaNote": "الإصدارات التجريبية تصل قبل المستقرة بأسابيع. جرّبها على سيرفر اختبار قبل سيرفرات الإنتاج."
  },
  "groups": {
    "new": "جديد",
    "improved": "تحسينات",
    "fixed": "إصلاحات",
    "security": "الأمان"
  },
  "compat": {
    "os": "الأنظمة المدعومة",
    "upgradeFrom": "يمكن تحديثه مباشرة من الإصدار {{version}} أو أحدث.",
    "running": "يعمل على:"
  }
}
